import React, { Component } from "react";

class Services extends Component {
  render() {
    return (
      <div>
        <div className="container">
          <a name="services" />
          <div className="section">
            <div className="row">
              <div className="col s12 m6">
                <div className="icon-block">
                  <h2 className="center brown-text">
                    <i className="material-icons">supervisor_account</i>
                  </h2>
                  <h5 className="center">
                    Supported Living Habilitation Supports/Natural Supports:
                  </h5>
                  <p className="light">
                    Moana Support supported living program provides support for
                    individuals in their homes and assists with the following:
                    medical appointments, grocery shopping, community
                    activities, independent living skills, money management and
                    any other support needed for people to live as independently
                    as possible. The program is individualized based on
                    individual needs and aspirations.
                  </p>
                </div>
              </div>
              <div className="col s12 m6">
                <div className="icon-block">
                  <h2 className="center brown-text">
                    <i className="material-icons">home</i>
                  </h2>
                  <h5 className="center">Host Home Services:</h5>
                  <p className="light">
                    Moana Support Host Home Program provides support for
                    individuals in a private certified home. These can be
                    family, or roommate type settings depending on the
                    preference of the individuals. Our Host Home Mentors assist
                    with the following: medical appointments, grocery shopping,
                    community activities, independent living skills, money
                    management and any other support needed for the individual
                    to live as independently as possible. The program is
                    individualized based on individual needs and aspirations.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col s12 m6">
                  <div className="icon-block">
                    <h2 className="center brown-text">
                      <i className="material-icons">receipt</i>
                    </h2>
                    <h5 className="center">
                      Personal Budget Assistant (representative payee):
                    </h5>
                    <p className="light">
                      Moana Support staff will provide assistance with various
                      financial matters. This includes fiscal training,
                      supervision of financial resources, savings, retirement,
                      earnings, funds monitoring, banking, budget management,
                      annual tax and fiscal record keeping.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
